(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function setEqualHeight() {
    if (window.innerWidth <= 750) {
      window.requestAnimationFrame(() => {
        document.querySelectorAll('[class*="footer-block--desktop-"]').forEach(block => {
          block.style.height = 'auto';
        });
      });
      return;
    }

    const blocks = [...document.querySelectorAll('[class*="footer-block--desktop-"]')];
    if (blocks.length === 0) return;

    let rows = [];
    let currentRow = [];
    let rowWidth = 0;

    window.requestAnimationFrame(() => {
      blocks.forEach(block => {
        block.style.height = 'auto';
      });
    });

    blocks.forEach(block => {
      const match = block.className.match(/footer-block--desktop-(\d+)/);
      const colSize = match ? parseInt(match[1]) : 0;

      if (rowWidth + colSize > 12) {
        rows.push(currentRow);
        currentRow = [];
        rowWidth = 0;
      }

      currentRow.push(block);
      rowWidth += colSize;
    });

    if (currentRow.length) rows.push(currentRow);

    rows.forEach(row => {
      const maxHeight = Math.max(...row.map(block => block.offsetHeight));
      window.requestAnimationFrame(() => {
        row.forEach(block => {
          block.style.height = `${maxHeight}px`;
        });
      });
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    setTimeout(setEqualHeight, 100);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setEqualHeight, 100);
  });

  if (Shopify.designMode) {
    const sectionId = "{{ section.id }}";

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail.sectionId === sectionId) {
        setTimeout(setEqualHeight, 100);
      }
    });
  
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === sectionId) {
        setTimeout(setEqualHeight, 100);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('customer-reviews-{{ section.id }}');
  if (!container) return;

  // Read initial and step from data attributes (theme settings)
  const initial = Number(container.getAttribute('data-initial')) || 8;
  const step = Number(container.getAttribute('data-step')) || 5;

  const grid = document.getElementById('reviews-grid-{{ section.id }}');
  if (!grid) return;

  // Live NodeList -> array
  const cards = Array.from(grid.querySelectorAll('.review-card'));
  const loadMoreBtn = document.getElementById('load-more-{{ section.id }}');

  // Ensure integer values and clamp
  let visibleCount = Math.min(Math.max(0, Math.floor(initial)), cards.length);

  // helper to show/hide a card index
  function showCard(index) {
    const card = cards[index];
    if (!card) return;
    card.classList.remove('is-hidden');
    card.classList.add('is-visible');
    card.style.display = ''; // let CSS handle display (block)
    card.setAttribute('aria-hidden', 'false');
  }
  function hideCard(index) {
    const card = cards[index];
    if (!card) return;
    card.classList.add('is-hidden');
    card.classList.remove('is-visible');
    card.style.display = 'none';
    card.setAttribute('aria-hidden', 'true');
  }

  // initialize: hide or show based on visibleCount
  cards.forEach((_, i) => {
    if (i < visibleCount) {
      showCard(i);
    } else {
      hideCard(i);
    }
  });

  // button logic
  if (!loadMoreBtn) return;

  function updateButton() {
    if (visibleCount >= cards.length) {
      loadMoreBtn.style.display = 'none';
      loadMoreBtn.setAttribute('aria-hidden', 'true');
      loadMoreBtn.setAttribute('aria-expanded', 'true');
    } else {
      loadMoreBtn.style.display = 'inline-block';
      loadMoreBtn.setAttribute('aria-hidden', 'false');
      loadMoreBtn.setAttribute('aria-expanded', 'false');
    }
  }

  updateButton();

  loadMoreBtn.addEventListener('click', () => {
    const start = visibleCount;
    const end = Math.min(cards.length, visibleCount + Math.max(1, Math.floor(step)));

    // Reveal exactly `step` items (or whatever remains)
    for (let i = start; i < end; i++) {
      // small stagger to make reveal feel smoother
      setTimeout(() => showCard(i), (i - start) * 40);
    }

    visibleCount = end;

    // After revealing, update the button
    updateButton();

    // keep focus on button for keyboard users unless done
    if (visibleCount < cards.length) loadMoreBtn.focus();
  });

  // Accessibility: allow keyboard Enter/Space handled automatically for <button>

});

  } catch(e) { console.error(e); }
})();
})();
